<template>
  <div id="loading-container">
    <div class="loading" :class="{ 'nodisplay' : suggestState && downloadState }"><i
      class='fas fa-circle-notch fa-spin fa-5x'></i></div>
    <pageHeader/>
    <b-container fluid class="bottom-margin">
      <b-container>
        <div class="body-width">
          <b-row>
            <b-col>
              <h1 class="predict-title">予測シミュレーション</h1>
            </b-col>
            <b-col class="predict-download">
              <button class="predict-download__download-button"
                      :class=" listState ? 'predict-download__download-button--clicked' : '' "
                      @click="onCsvSelect">
                CSV <i class="fas fa-download"></i>
              </button>
              <ul class="predict-download__ul"
                  :class=" listState ? 'predict-download__ul--display' : 'predict-download__ul--nodisplay' ">
                <li class="predict-download__li">
                  <a class="predict-download__a-item" @click="onCsvMarkdown">マークダウン</a>
                </li>
                <li class="predict-download__li">
                  <a class="predict-download__a-item" @click="onCsvItemOrder">追加発注(品番)</a>
                </li>
                <li class="predict-download__li">
                  <a class="predict-download__a-item" @click="onCsvSkuOrder">追加発注(SKU)</a>
                </li>
                <li class="predict-download__li">
                  <a class="predict-download__a-item"
                     @click="onPredictCsvItemMarkdown">マークダウン(日別)</a>
                </li>
                <li class="predict-download__li">
                  <a class="predict-download__a-item" @click="onPredictCsvItemOrder">追加発注(日別)</a>
                </li>
              </ul>
            </b-col>
          </b-row>
          <b-row style="margin: 0px;">
            <b-col cols="2" style="padding: 0px;">
              <categorylist/>
            </b-col>
            <b-col cols="5" style="padding: 0px;">
              <itemlist ref="itemlist"/>
            </b-col>
            <b-col cols="5" style="padding: 0px;">
              <skulist/>
            </b-col>
          </b-row>
          <b-row style="margin: 0px;">
            <b-col md="4" style="padding: 0px;">
              <detail/>
            </b-col>
            <b-col md="8" style="margin-left: -52px; padding: 0px;">
              <simulate/>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </b-container>
  </div>
</template>


<script>
import pageHeader from '../../pageheader'
import categorylist from './categorylist/categorylist.vue'
import itemlist from './itemlist/itemlist.vue'
import skulist from './skulist/skulist.vue'
import detail from './detail/detail.vue'
import simulate from './simulate/simulate.vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'predict',

  data() {
    return {
      listState: false
    }
  },

  components: {
    pageHeader,
    categorylist,
    itemlist,
    skulist,
    detail,
    simulate
  },

  computed: {
    ...mapGetters('predict', ['suggestState']),
    ...mapGetters('itemlist', ['downloadState'])
  },

  methods: {
    /**
     * item一覧のダウンロードリスト表示
     */
    onCsvSelect() {
      this.listState = true
      // 5秒後に非表示
      setTimeout(this.timeoutState, 5000)
    },

    /**
     * ダウンロードリストを非表示
     */
    timeoutState() {
      this.listState = false
    },

    /**
     * item一覧のマークダウンCSVのダウンロード
     */
    onCsvMarkdown() {
      const weeklyMarkDownloadClient = ['RENOWN', 'TUTUANNA', 'STRIPE', 'TSI']
      if (_.includes(weeklyMarkDownloadClient, sessionStorage.clientId)) {
        this.$refs.itemlist.onWeeklyMarkDownload()
      } else {
        this.$refs.itemlist.onMarkDownload()
      }
      this.listState = false
    },

    /**
     * item一覧の追加発注CSV(品番)のダウンロード
     */
    onCsvItemOrder() {
      this.$refs.itemlist.onItemOrderDownload()
      this.listState = false
    },

    /**
     * item一覧の追加発注CSV(SKU)のダウンロード
     */
    onCsvSkuOrder() {
      this.$refs.itemlist.onSkuOrderDownload()
      this.listState = false
    },

    /**
     * 日別予実ログマークダウン(item)のダウンロード
     */
    onPredictCsvItemMarkdown() {
      this.$refs.itemlist.onPredictLogDownload("markdown")
      this.listState = false
    },

    /**
     * 日別予実ログ追加発注(item)のダウンロード
     */
    onPredictCsvItemOrder() {
      this.$refs.itemlist.onPredictLogDownload("order")
      this.listState = false
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="../../unit.scss" lang="scss"></style>
<style lang="scss">
.predict-download {
  text-align: right;
  padding-top: 8px;
  margin-right: 6px;
  height: 40px;

  .predict-download__download-button {
    background-color: #0b7bfe;
    cursor: pointer;
    color: #fff;
    padding: 5px 15px;
    text-align: center;
    text-decoration: none;
    font-size: 12px;

    border-radius: 3px;
    border: 1px solid #e7e9eb;
  }

  .predict-download__download-button--clicked {
    background-color: #01244c;
  }

  .predict-download__ul {
    position: relative;
    top: 0px;
    left: 170px;
    z-index: 100;
    width: 150px;
    font-size: 12px;
    margin: auto;

    .predict-download__li {
      list-style: none;

      .predict-download__a {
        background-color: #fff;
        display: block;
        text-align: left;
        padding: 5px 10px;
        cursor: pointer;
      }

      .predict-download__a:hover {
        background: #d6d9dc;
      }

      .predict-download__a-item {
        @extend .predict-download__a;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
    }

    .predict-download__li:not(:last-child) {
      border-bottom: 1px solid #d6d9dc;
    }
  }

  .predict-download__ul--nodisplay {
    display: none;
  }

  .predict-download__ul--display {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// predict.vue?2f1265c6